import { AxiosResponse } from 'axios';

import { TMeetingRoomForm } from '@/features/NewBooking/useMeetingRoomForm.tsx';

import { IBookingObjectTypesResponse } from '@/shared/types/bookingObjects.types.ts';

import { ApiRoutes } from '../constant/api';
import { api } from '../helpers/axios';
import {
	BookingsForModerator,
	IBookingRadar,
	IBookingRadarRequest,
	IBookingRequestType,
	IExternalBookingResponse,
	ICarBookingsResponse,
	IGuest,
	ITrackCarAccessRequestType,
	PersonBookingResponseType,
	PersonBookingsObject,
	TAllBookingsResponseType,
	TBookingRadarResponse,
} from '../types/booking.types';

export const bookingApi = {
	getBookingById: (bookingId: string) =>
		api.get(`${ApiRoutes.Bookings}/${bookingId}`).then((res) => res.data as PersonBookingsObject),
	getAllBookingsByDate: (from: Date, to: Date) =>
		api
			.get(`${ApiRoutes.Bookings}`, {
				params: {
					start: from,
					finish: to,
				},
			})
			.then((res) => res.data as TAllBookingsResponseType),
	getBookingsForInitiator: () =>
		api
			.get(`${ApiRoutes.Bookings}/for_initiator`)
			.then((res) => res.data as PersonBookingResponseType),
	getBookingsForClient: () =>
		api
			.get(`${ApiRoutes.Bookings}/for_client`)
			.then((res) => res.data as PersonBookingResponseType),

	getCarBookingsForClient: (personId: number) =>
		api
			.get(`${ApiRoutes.Bookings}/for_client/car/${personId}`)
			.then((res) => res.data as ICarBookingsResponse),

	reportPlaceWasTaken: (payload: FormData) =>
		api.post(`${ApiRoutes.Bookings}/place_was_taken`, payload, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}),

	getBookingsForModerator: () =>
		api
			.get(`${ApiRoutes.Bookings}/for_moderator`, {
				params: {
					withConfirm: true,
				},
			})
			.then((res) => res.data as BookingsForModerator[]),

	createNewBooking: (payload: IBookingRequestType): Promise<AxiosResponse<unknown>> =>
		api.post(ApiRoutes.Bookings, payload),
	editBooking: ({
		bookingId,
		payload,
	}: {
		bookingId: number;
		payload: IBookingRequestType;
	}): Promise<AxiosResponse<unknown>> => api.put(`${ApiRoutes.Bookings}/${bookingId}`, payload),
	finishBooking: (bookingId: number) => api.put(`${ApiRoutes.Bookings}/${bookingId}/finish`),
	deleteBooking: (bookingId: number) => api.delete(`${ApiRoutes.Bookings}/${bookingId}`),

	trackCarAccess: (data: ITrackCarAccessRequestType) =>
		api.post(`${ApiRoutes.Bookings}/car_access`, data),

	createFastNewBooking: (payload: IBookingRequestType): Promise<AxiosResponse<unknown>> =>
		api.post(`${ApiRoutes.Bookings}/fast`, payload),
	// Бэкенд сам разбивает период на брони по дням с одинаковым временем начала и окончания
	createMultipleBooking: (payload: IBookingRequestType): Promise<AxiosResponse<unknown>> =>
		api.post(`${ApiRoutes.Bookings}/multiple`, payload),
	createExternalBooking: (payload: IBookingRequestType): Promise<AxiosResponse<unknown>> =>
		api.post(`${ApiRoutes.Bookings}/external`, payload),
	getExternalBooking: (bookingId: string): Promise<IExternalBookingResponse> =>
		api
			.get<IExternalBookingResponse>(`${ApiRoutes.Bookings}/external/${bookingId}`)
			.then((res) => res.data),
	addGuestToExternalBooking: ({
		bookingId,
		payload,
		returnUrl,
	}: {
		bookingId: string;
		returnUrl: string;
		payload: IGuest[];
	}) =>
		api.post(`/guest/${bookingId}/external`, payload, {
			params: {
				returnUrl,
			},
		}),
	getBookingRadar: (
		clientId?: number,
		initiatorId?: number,
		objectId?: number,
	): Promise<IBookingRadar[]> =>
		api
			.get(`/radar`, {
				params: { client_id: clientId, initiator_id: initiatorId, object_id: objectId },
			})
			.then((res) => (res.data as TBookingRadarResponse)?.objects),
	createBookingRadar: (payload: IBookingRadarRequest) => api.post(`/radar`, payload),
	deleteBookingRadar: (radarId: number) => api.delete(`/radar/${radarId}`),
};
